import {
  Legal,
  Reset,
  Confirmation,
  Welcome
} from './assets/pages'

import {
  Dash,
  Device,
  Export,
  Firmware,
  InformationModel,
  Login,
  NotFound,
  Notifications,
  ResetPassword,
  Theme,
  User
} from './components'

// Routes
const routes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/reset',
    component: ResetPassword
  },
  {
    path: '/legal',
    component: Legal
  },
  {
    path: '/reset/:code/:lang',
    component: Reset
  },
  {
    path: '/confirmation/:token/:lang',
    component: Confirmation
  },
  {
    path: '/welcome/:lang',
    component: Welcome
  },
  {
    path: '/',
    component: Dash,
    children: [
      {
        path: 'device',
        alias: '',
        component: Device,
        name: 'Device List',
        meta: {description: ''}
      },
      {
        path: 'device/:sn',
        component: Device,
        name: 'Device List',
        meta: {description: ''}
      },
      {
        path: 'export',
        component: Export,
        name: 'Export',
        meta: {description: ''}
      },
      {
        path: 'firmware',
        component: Firmware,
        name: 'Firmware List',
        meta: {description: ''}
      },
      {
        path: 'informationModel',
        component: InformationModel,
        name: 'Information Model',
        meta: {
          description: ''
        }
      },
      {
        path: 'notifications',
        component: Notifications,
        name: 'Notifications',
        meta: {
          description: ''
        }
      },
      {
        path: 'theme',
        component: Theme,
        name: 'Theme',
        meta: {description: ''}
      },
      {
        path: 'theme/:id',
        component: Theme,
        name: 'Theme',
        meta: {description: ''}
      },
      {
        path: 'user',
        component: User,
        name: 'User List',
        meta: {description: ''}
      },
      {
        path: 'user/:email',
        component: User,
        name: 'User List',
        meta: {description: ''}
      }
    ]
  },
  {
    // not found handler
    path: '*',
    component: NotFound
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js